import { createFileRoute } from "@tanstack/react-router";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/terms-condition")({
  head: () => ({
    meta: [
      { title: `Terms & Conditions | ${siteConfig.siteName}` },
      {
        name: "description",
        content: `The terms and conditions that govern your use of ${siteConfig.siteName}.`,
      },
      { property: "og:title", content: `Terms & Conditions — ${siteConfig.siteName}` },
      { property: "og:url", content: `${siteConfig.domain}/terms-condition` },
    ],
    links: [{ rel: "canonical", href: `${siteConfig.domain}/terms-condition` }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-14">
      <h1 className="text-4xl font-bold tracking-tight text-foreground">Terms & Conditions</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: January 1, 2026</p>

      <div className="prose-article mt-6">
        <p>
          Welcome to {siteConfig.siteName}. By accessing or using {siteConfig.domain} (the
          "Site"), you agree to be bound by these Terms & Conditions. If you do not agree, please
          discontinue use of the Site.
        </p>

        <h2>1. Use of the Site</h2>
        <p>
          You may access and use the Site for personal, non-commercial informational purposes.
          You agree not to misuse the Site, attempt to interfere with its normal operation, or
          access it in a manner that violates any applicable law.
        </p>

        <h2>2. Intellectual property</h2>
        <p>
          All content on the Site — including text, graphics, logos, images, and software — is
          the property of {siteConfig.siteName} or its licensors and is protected by copyright,
          trademark, and other intellectual property laws. You may not reproduce, distribute, or
          create derivative works from this content without our prior written consent.
        </p>

        <h2>3. Editorial content and disclaimers</h2>
        <p>
          The information on this Site is provided for general informational purposes only. While
          we make reasonable efforts to keep our reviews and guides accurate and up to date,
          software features, pricing, and vendor policies change frequently. Nothing on this Site
          constitutes legal, financial, or professional advice. You should verify any
          product-specific information directly with the vendor before making a purchase decision.
        </p>

        <h2>4. Third-party links and advertising</h2>
        <p>
          The Site contains links to third-party websites and may display advertisements served
          by Google AdSense and other advertising partners. We are not responsible for the
          content, privacy practices, or availability of any third-party site or advertiser. Your
          interactions with third parties are solely between you and that third party.
        </p>

        <h2>5. Affiliate disclosure</h2>
        <p>
          Some of the links on this Site are affiliate links, meaning we may earn a commission if
          you click through and make a purchase, at no additional cost to you. Affiliate
          relationships do not influence our editorial rankings or opinions.
        </p>

        <h2>6. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, {siteConfig.siteName} and its contributors will
          not be liable for any indirect, incidental, special, or consequential damages arising
          out of or in connection with your use of the Site or any content contained herein.
        </p>

        <h2>7. Modifications</h2>
        <p>
          We reserve the right to modify or discontinue the Site (or any portion of it) at any
          time without notice, and to update these Terms from time to time. Continued use of the
          Site after any change constitutes acceptance of the updated Terms.
        </p>

        <h2>8. Governing law</h2>
        <p>
          These Terms are governed by the laws of the United States, without regard to conflict
          of laws principles. Any disputes will be resolved in the state or federal courts
          located in the United States.
        </p>

        <h2>9. Contact</h2>
        <p>
          Questions about these Terms? Reach us through our contact page.
        </p>
      </div>
    </section>
  );
}
